import React from 'react';
import { format, isSameDay, isToday } from 'date-fns';
import { DateDividerWrapper } from './style';
var DateDivider = React.memo(function (_a) {
    var message = _a.message, previousMessage = _a.previousMessage;
    var date = message.dateCreated;
    var formattedDate = format(date, 'ccc, d MMM');
    var isSentToday = isToday(date);
    var previousTimestamp = previousMessage === null || previousMessage === void 0 ? void 0 : previousMessage.dateCreated;
    var isPreviousMessageTheSameDate = previousTimestamp && isSameDay(date, previousTimestamp);
    return previousMessage ? (React.createElement(React.Fragment, null, isPreviousMessageTheSameDate ? ('') : isSentToday ? (React.createElement(DateDividerWrapper, null, "Today")) : (React.createElement(DateDividerWrapper, null, formattedDate)))) : (React.createElement(DateDividerWrapper, null, isSentToday ? 'Today' : formattedDate));
});
export default DateDivider;
//# sourceMappingURL=index.js.map